import { useContext } from "react";

import type { HandlingUnit } from "~/shared/types/quote-details-types.ts";

import { QuoteDetailsContext } from "../../../../context/quote-details-context.tsx";
import { ShipmentItem } from "../shipment-item/shipment-item.tsx";

type ItemDetailsProps = {
	showHazmatDetails?: boolean;
	items: HandlingUnit[];
	itemValidationErrors?: Record<number, Set<string>>;
	onClearItemFieldError?: (itemId: number, fieldKey: string) => void;
};

export const ItemDetails = ({
	showHazmatDetails = false,
	items,
	itemValidationErrors,
	onClearItemFieldError,
}: ItemDetailsProps) => {
	const { handleItemUpdate } = useContext(QuoteDetailsContext);

	return (
		<div>
			{items.map((item) => (
				<ShipmentItem
					key={item.id}
					handleItemUpdate={handleItemUpdate}
					item={item}
					onClearFieldError={onClearItemFieldError}
					showHazmatDetails={showHazmatDetails}
					validationErrors={itemValidationErrors?.[item.id]}
				/>
			))}
		</div>
	);
};
